'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _nodeUuid = require('node-uuid');

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

var _emitter = require('./emitter');

var _emitter2 = _interopRequireDefault(_emitter);

var _transaction = require('./transaction');

var _transaction2 = _interopRequireDefault(_transaction);

var CurrentSession = null;
var TransactionById = new Map();

/******************************************************************************
 * The Session class fascilitates tracking of queries when rendering on 
 * server and client so that we may hydrade the client with data provided
 * during the page render.
 *
 * If a query is invoked with an active session it will be associated with
 * that session through the .beginTransaction() call, otherwise the query
 * will run session-less which will simply disable caching which is useful
 * when running through our rest api.
 *
 * Currently, when rendering on the server we discard the session after each
 * request but this is something that we could keep track of during an actual
 * authenticated session of a user in create for example. We could even
 * extend the Session to work against a global cache so that multiple
 * clients will not be fetching the same model etc. For now, we're keeping it
 * fairly simple though until we can figure everything out.
 */

var Session = (function (_Emitter) {
	_inherits(Session, _Emitter);

	_createClass(Session, null, [{
		key: 'bind',
		value: function bind(session, callback) {
			var previousSession = Session.Current;
			Session.Current = session;
			var result = callback();
			Session.Current = previousSession;
			return result;
		}
	}, {
		key: 'unbind',
		value: function unbind(callback) {
			return Session.bind(null, callback);
		}
	}, {
		key: 'create',
		value: function create(id, data) {
			var session = new Session(id, data);
			Session.Current = session;
			return session;
		}
	}, {
		key: 'Current',
		get: function get() {
			return CurrentSession;
		},
		set: function set(sess) {
			CurrentSession = sess;
		}
	}]);

	function Session() {
		var id = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
		var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, Session);

		_get(Object.getPrototypeOf(Session.prototype), 'constructor', this).call(this);

		this.id = id || _nodeUuid2['default'].v4();
		this.transactions = data.transactions || [];
		this.queries = data.queries || {};
	}

	_createClass(Session, [{
		key: 'isQueryCached',
		value: function isQueryCached(key) {
			return key in this.queries;
		}
	}, {
		key: 'getCachedQuery',
		value: function getCachedQuery(key) {
			return this.queries[key] || null;
		}
	}, {
		key: 'beginTransaction',
		value: function beginTransaction(id, mode, callback) {
			var _this = this;

			// keep track of the request in the global pool
			if (TransactionById.has(id)) {
				return TransactionById.get(id);
			}

			// validate arguments and default to BLOCKING mode transaction
			if (typeof mode === 'function' && callback === undefined) {
				callback = mode;
				mode = _transaction2['default'].Mode.BLOCKING;
			}

			// create transaction and add it to global pool and session pending
			var tx = new _transaction2['default'](mode);

			this.transactions.push(tx);
			TransactionById.set(id, tx);

			// helper to remove from pools
			var clearTransaction = function clearTransaction() {
				TransactionById['delete'](id);

				_this.transactions = Array.from(TransactionById).map(function (entry) {
					return entry[1];
				});

				_this.emit('transaction:end', tx);
			};

			// observe the transaction
			tx.then(clearTransaction)['catch'](clearTransaction);

			callback(tx);

			this.emit('transaction:begin', tx);

			return tx;
		}
	}]);

	return Session;
})(_emitter2['default']);

exports['default'] = Session;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/session.js
// module id = VY6S
// module chunks = 15